import React from "react";
import "../../css/Popup.css"; 
import logo from "../../images/24k1.jpg"; 
import indian from "../../images/india.jpeg"; 
import pic from "../../images/popupimg.webp";

const Popup1 = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // If popup is not open, don't render anything

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent form submission from refreshing the page

    // Access form data correctly using refs or event.target
    const formData = {
      name: event.target.name.value,
      email: event.target.email.value,
      mobile: event.target.mobile.value,
      requirement: event.target.requirement.value,
    };

    alert("Form Data: " + JSON.stringify(formData)); // Debugging line
    
    try {
      const response = await fetch("/api/popup-lead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      
      const result = await response.json();
      if (response.ok) {
        alert("submitted successfully!");
      } else {
        alert("Failed to submit lead: " + result.error);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <span className="popup-close fw-bold" onClick={onClose}>
          &times;
        </span>
        <div className="popup-body">
          <div className="popup-image">
            <img src={pic} alt="Pincode Pillars" className="popup-img" />
          </div>
          <div className="popup-form">
            <h2>
              Expert Consultation by{" "}
              <span className="highlight">Professionals</span>
            </h2>
            <img
              src={logo}
              alt="Backbone Pillars Logo"
              className="popup-logo"
            />
            {/* Attach onSubmit to the form */}
            <form className="form1" onSubmit={handleSubmit}>
              <input
                className="form-control"
                type="text"
                id="name"
                name="name"
                required
                placeholder="Name"
              />

              <input
                className="form-control"
                type="email"
                id="email"
                name="email"
                required
                placeholder="Email"
              />

              <div className="mobile-input form-control">
                <div className="country-code">
                  <img src={indian} alt="India Flag" className="flag-icon" />
                  <span className="code">+91</span>
                </div>
                <input
                  type="tel" // Use type "tel" for mobile numbers
                  id="mobile"
                  name="mobile"
                  required
                  placeholder="Mobile*"
                  className="mobile-number-input" // Add a class for styling
                />
              </div>

              <textarea
                className="form-control mt-2"
                id="requirement"
                name="requirement"
                placeholder="Please share your requirement here"
                rows="4"
                required
              ></textarea>

              <button
                className="main-btn1 pointer text-center animate fw-bold"
                type="submit" // Use "submit" here instead of onClick
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup1;
